import { fontSize } from "config/styles/fonts";

const styles = {
  inputWrap: (error?: boolean) => ({
    "& input": {
      width: "100%",
      height: "40px",
      padding: "10px 16px",
      borderRadius: "4px",
      color: "text.primary",
      lineHeight: "normal",
      fontSize: fontSize.m,
      border: error ? "2px solid" : "1px solid",
      borderColor: error ? "error.main" : "gray.disabled",
      "&:hover": {
        borderColor: error ? "error.main" : "text.secondary",
      },
      "&:focus-visible": {
        outlineColor: error ? "error.main" : "text.secondary",
      },
      "&::placeholder": {
        color: error ? "error.main" : "gray.disabled",
      },
    },
  }),
  errorText: {
    color: "error.main",
    ml: 0,
  },
};

export default styles;
